module.exports = __webpack_public_path__ + "img/corporategovernance-436x218-brandstory.7d03338c.jpg";